
  var _extcart_info = null;

  var _dev_view_layout_selector = "";
  var _dev_view_layout_selector2 = "";


  var _quantity_ajax = null;
  var _checkbox_ajax = null;

  var _progressbar_libs = [];

  function set_extcart_info(extcart_info)
  {
    if(typeof _extcart_info !== 'undefined')
    {
      _extcart_info = extcart_info;
    }
  }

  function get_extcart_info()
  {
    if(_extcart_info != undefined)
    {
      return _extcart_info;
    }
  }

  function set_subcart_item_list(subcart_id,item_list)
  {
    for(i = 0; i < _extcart_info.subcart_list.length; i++)
    {
      //_console_log_debug("set_subcart_item_list::");
      if(_extcart_info.subcart_list[i].subcart_id === subcart_id)
      {
        _extcart_info.subcart_list[i].item_list = item_list;
        //_console_log_debug("set_subcart_item_list::");
        //_console_log_debug(_extcart_info);
        break;
      }
    }
  }

  function get_subcart_by_id(subcart_id)
  {
    if(_extcart_info == null)
    {
      return null;
    }
    if(typeof _extcart_info.subcart_list == 'undefined' || _extcart_info.subcart_list == null)
    {
      return null;
    }

    for(i = 0; i < _extcart_info.subcart_list.length; i++)
    {
      if(_extcart_info.subcart_list[i].subcart_id == subcart_id)
      {
        return _extcart_info.subcart_list[i];
      }
    }

    return null;
  }


  function get_subcart_obj(subcart_id)
  {
     return $("#id_extcart").find(".cl_subcart[subcart_id="+subcart_id+"]");
  }

  function get_free_shipping_thresold_price(subcart_id)
  {
    switch(subcart_id)
    {
      case "SUBCART_00"://일반배송
        return  "99" * 1;
      case  "SUBCART_05"://꽃마Fresh
        return "0" * 1;
      default:
        return 0;
    }
  }

  function show_extcart(extcart_info)
  {
    _console_log("[show_extcart::extcart_info]");
    //_console_log_debug(extcart_info);

    hideLoadingSpinner();

    show_header_cart_count(extcart_info);

    set_extcart_info(extcart_info);

    if(typeof extcart_info.subcart_list == 'undefined' || extcart_info.subcart_list == null)
    {
      // Cart is empty
      //_console_log("Cart is empty.");
      show_empty_extcart();
      return;
    }

    // clear extcart view
    var extcart_container_obj = $("#id_extcart");
    extcart_container_obj.html("");

    for(i = 0; i < extcart_info.subcart_list.length; i++)
    {

      subcart_name = extcart_info.subcart_list[i].subcart_title;

      _console_log("[" + i + "] : " + subcart_name);

      var subcart_info = extcart_info.subcart_list[i];

      show_subcart(subcart_info.subcart_id);

    }
  }


  function show_subcart(subcart_id)
  {
    _console_log("[show_subcart::subcart_id]");
    _console_log_debug(subcart_id);

    hideLoadingSpinner();

    var subcart_info = get_subcart_by_id(subcart_id);
    _console_log_debug(subcart_info);
    var subcart_obj = get_subcart_obj(subcart_id);

    if(subcart_obj != null && subcart_info == null)
    {
      subcart_obj.html("");

    }else{

      show_extcart_add_subcart(subcart_info);

      //장바구니 주문합계 & 적립꽃송이 합계 표시
      //show_subcart_sum_info(subcart_info.subcart_id);

      init_freedelivery_bar(subcart_info);
    }


  }

  function show_empty_extcart()
  {
    var extcart_container_obj = $("#id_extcart");
    extcart_container_obj.html($("#id_extcart_empty").html());
  }

  function show_extcart_add_subcart(subcart_info)
  {
    var extcart_container_obj = $("#id_extcart");

    //기존 subcart가 있으면 유지한다.
    var subcart_obj = get_subcart_obj(subcart_info.subcart_id);

    if(subcart_obj.attr("subcart_id") != subcart_info.subcart_id){
      subcart_obj = $("#id_subcart_template").clone(true);
      extcart_container_obj.append(subcart_obj);
    }

    var subcart_title_obj = subcart_obj.find(".cl_cart_title_layout");
    subcart_obj.attr("id", "id_mobile_wrapper");
    subcart_obj.removeClass("cl_subcart_template");
    subcart_obj.attr("subcart_id", subcart_info.subcart_id);

    // subcart_title
    subcart_obj.find(".cl_cart_title").html(subcart_info.subcart_title);

    //subcart에 맞게 [주문하기]버튼명 변경
    if(subcart_info.subcart_id !== "SUBCART_00"){
      subcart_obj.find(".cl_btn_checkout").html(subcart_info.subcart_title + " 주문하기");
    }

    // subcart checkout button
    subcart_obj.find(".cl_btn_checkout").attr("subcart_id", subcart_info.subcart_id);

    var subcart_item_list_container_obj = subcart_obj.find(".cart_item_wrapper");
    subcart_item_list_container_obj.empty();


    //[NOTE] 소팅 : 특가상품 맨위로 위치
    var i = 0;
    var special_price_item_list = [];
    for(i = 0; i < subcart_info.item_list.length; )
    {
      var item_info = subcart_info.item_list[i];
      if(item_info.is_special_price !== undefined && item_info.is_special_price){
        special_price_item_list.push(item_info);
        subcart_info.item_list.splice(i, 1);
        continue;
      }
      i++;
    }
    if(special_price_item_list.length > 0){
      subcart_info.item_list = special_price_item_list.concat(subcart_info.item_list);
    }

    for(i = 0; i < subcart_info.item_list.length; i++)
    {
      show_extcart_add_item_to_subcart(subcart_item_list_container_obj, i, subcart_info.item_list[i]);
    }

    show_subcart_sum_info(subcart_info.subcart_id);

    switch (subcart_info.subcart_id )
    {
      case "SUBCART_K2K_01":
        subcart_obj.find(".cart__gift_message_wrapper").show();
        break;
      case "SUBCART_13"://D2C
        subcart_obj.find("p.cl_cart_cpoint_reserve_sum").hide();
        break;
      case "SUBCART_31":
      case "SUBCART_15"://기프트카드 장바구니인 경우 "꽃송이적립,배송비,Tax" 안내 문구 제거함
        subcart_obj.find("p.subcart_shipping_fee_tax_discount_info_text").hide();
        subcart_obj.find("p.cl_cart_cpoint_reserve_sum").hide();
        break;
      case "SUBCART_04": //무료별도배송
        subcart_title_obj.find("img").attr("src","//www.cconmausa.com/cdn/shop/files/icon_subcart_freesplit.png?v=12671609411741626551");
        break;
      case "SUBCART_05"://꽃마Fresh
        subcart_title_obj.find("img").attr("src","//www.cconmausa.com/cdn/shop/files/icon_subcart_fresh.png?v=5830195798361788778").css("filter","hue-rotate(88deg) brightness(1.1)");
        break;
      case "SUBCART_21"://창고대개방
        subcart_obj.find("p.cl_cart_cpoint_reserve_sum").hide();
        subcart_obj.find(".cl_unusable_cpoint_and_code").show();
        break;
      case "SUBCART_22"://창고대개방 무료별도배송
        subcart_obj.find("p.cl_cart_cpoint_reserve_sum").hide();
        subcart_obj.find(".cl_unusable_cpoint_and_code").show();
        break;
      default:
        subcart_title_obj.find("img").attr("src","//www.cconmausa.com/cdn/shop/files/icon_subcart_normal.png?v=9718646284709028996");
    }



    subcart_obj.show();
  }


  function init_freedelivery_bar(subcart_info)
  {

    var subcart_obj = get_subcart_obj(subcart_info.subcart_id);
    var bar_obj = subcart_obj.find(".cl_freedelivery_bar");
    bar_obj.hide();
    var index = bar_obj.attr("index")? bar_obj.attr("index") * 1 : -1;

    if(index >= 0){
      try{
        bar_obj.show();
        _progressbar_libs[index].set_current_price(subcart_info.checked_total_price);
      }catch (err){
        _console_log(err);
      }

      return;
    }

    var max_price = get_free_shipping_thresold_price(subcart_info.subcart_id);
    if(max_price <= 0)
      return;


    var bar_container_obj = bar_obj.find(".cl_bar_container");
    var bar_container_id = "id_bar_container_" + subcart_info.subcart_id;
    var max_price_obj = bar_obj.find(".cl_max_price");
    var required_price_obj = bar_obj.find(".cl_required_price");

    //무료배송 목표가
    max_price_obj.html( "$" + Math.floor(max_price*100)/100);


    required_price_obj.html("$" + max_price);

    bar_obj.attr("subcart_id",subcart_info.subcart_id);

    bar_container_obj.prop("id",bar_container_id);


    try{
      require(['progressbar'], function (ProgressBar) {

        try{
          var progressbar = new ProgressBar.Line("#"+bar_container_id, {
            strokeWidth: 4,
            easing: 'easeInOut',
            duration: 1500,
            color: (subcart_info.subcart_id === "SUBCART_05") ? '#4C8AC9' : '#F35050',
            trailColor: '#F1F2F5',
            trailWidth: 4,
            svgStyle: {width: '100%', height: '100%'}
          });


          /*progressbar.bar_container_obj = bar_container_obj;
          progressbar.max_price_obj = max_price_obj;
          progressbar.cur_price_obj = bar_obj.find(".cl_cur_price");
          progressbar.indicator_obj =  bar_obj.find(".cl_indicator");
          progressbar.indicator_container_obj = bar_obj.find(".cl_indicator_container");
          progressbar.indicator_quide_obj =  bar_obj.find(".cl_price_guide");
          */
          progressbar.required_price_obj =required_price_obj;
          progressbar.required_guide_obj = bar_obj.find(".cl_required_quide");
          progressbar.max_price = max_price;
          progressbar.cur_price = 0;
          progressbar.subcart_id = subcart_info.subcart_id;

          progressbar.set_current_price = function(cur_price){
            //현재금액
            var cur_value = Math.min(1.0,((cur_price * 1) / this.max_price));
            this.cur_price = Math.floor(cur_price*100)/100;

            /*this.cur_price_obj.html("$0");
            this.cur_price_obj.attr("to_val",this.cur_price);
            this.cur_price_obj.val(0);
            this.cur_price_obj.animate({val:10},{
              duration:1000,
              step:function(val){
                var to_val = $(this).attr("to_val");
                var cur_price = to_val * ((val)*0.1);
                cur_price =  Math.floor(cur_price*100)/100;;
                $(this).html("$" + cur_price);
              }
            });
            */

            this.animate(cur_value);

            //this.set_indicator_position(cur_value);
            this.set_required_price(this.cur_price);
          };

          progressbar.set_indicator_position = function (cur_value)
          {
            var contain_width =  this.indicator_container_obj.width();
            var indicator_left = contain_width * cur_value - (this.indicator_obj.width()*0.5);
            this.indicator_obj.css("left",indicator_left + "px");
            this.max_price_obj.show();

            this.indicator_container_obj.css("opacity",0);
            this.indicator_container_obj.animate({opacity:1},2000);


            //'$99담겨있어요' 표시 위치 조정(indicator와 겹치는 경우 hide한다)
            var pos_x = 0;
            if(indicator_left > contain_width * 0.5){

              pos_x = (indicator_left - this.indicator_quide_obj.width() - 10);
              this.indicator_quide_obj.css("left",pos_x + "px");

              if(this.max_price_obj.offset().left > this.indicator_quide_obj.offset().left
                      && this.max_price_obj.offset().left <= this.indicator_obj.offset().left + this.indicator_obj.width())
              {
                this.max_price_obj.hide();
              }

            }else{
              pos_x = (indicator_left +  this.indicator_obj.width() + 10);
              this.indicator_quide_obj.css("left",pos_x + "px");
            }


          };
          progressbar.set_required_price = function (cur_price){
            //필요금액 문구
            this.required_guide_obj.html("더 담으면 무료배송");
            this.required_price_obj.show();

            //필요금액
            var required_price = this.max_price >  cur_price ?  this.max_price - cur_price : 0;
            this.required_price_obj.html("$" + this.max_price);

            this.required_price_obj.val(0);
            this.required_price_obj.attr("to_val",required_price);
            this.required_price_obj.attr("from_val" , this.max_price);
            this.required_price_obj.animate({val:10},{
              duration:1500,
              step:function(val){
                // console.log($(this));
                var to_val = $(this).attr("to_val");
                var from_val = $(this).attr("from_val");
                var cur_required_price = from_val - ((from_val - to_val) * (( val)*0.1));
                cur_required_price =  Math.floor(cur_required_price*100)/100;
                $(this).html("$" + cur_required_price);
                if(cur_required_price <= 0){
                  $(this).parent().find(".cl_required_quide").html("무료로 배송해드립니다");
                  $(this).hide();
                  $(this).stop();
                }
              }
            });

          };
          bar_obj.attr("index",_progressbar_libs.length);
          _progressbar_libs[_progressbar_libs.length] = progressbar;


          progressbar.set_current_price(subcart_info.checked_total_price);

          bar_obj.show();
        }catch(err){
          console.log(err);
          bar_obj.hide();
        }

      });

    }catch (err){
      console.log(err);
      bar_obj.hide();
    }
  }



  function show_extcart_add_item_to_subcart(subcart_item_list_container_obj, index, item_info)
  {



    var subcart_item_template_obj = $(".cl_subcart_item_template_wrapper .cl_subcart_item_template");

    var subcart_item_obj = subcart_item_template_obj.clone(true);
    subcart_item_obj.removeClass("cart_row_div_template");

    subcart_item_list_container_obj.append(subcart_item_obj);

    subcart_item_obj.attr("variant_id",item_info.variant_id);

    // url
    subcart_item_obj.find(".cart__image").attr("href", item_info.url + _dev_view_layout_selector2);

    // image_src
    subcart_item_obj.find(".cart__image img").attr("src", item_info.image_src).attr("alt", item_info.title);

    // variant_id at checkbox
    subcart_item_obj.find(".subcart_item_chk").attr("product_id" , item_info.product_id);
    subcart_item_obj.find(".subcart_item_chk").attr("variant_id", item_info.variant_id);

    //한국직배송(D2C) 발송일자
    if(item_info.d2c_shipping_schedule !== undefined)
    {
      require(['d2c-shipment-date'], function (d2cShipmentDate) {

        var kr_shipping_schedued_at_str = d2cShipmentDate(item_info.d2c_shipping_schedule.d2c_workingday_tag,item_info.title);
        if(!is_empty(kr_shipping_schedued_at_str)){
          subcart_item_obj.find(".cl_d2c_shipping_schedule").text(kr_shipping_schedued_at_str).show();
        }

      });
      //subcart_item_obj.find(".cl_d2c_shipping_schedule").text(item_info.d2c_shipping_schedule.kr_shipping_scheduled_at_str).show();
    }

    //타임딜 시간표시
    if(item_info.timedeal_tag !== undefined)
    {
      window.timedeal_badge.init_for_badge(subcart_item_obj.find(".cl_timedeal_wrap"),item_info.timedeal_tag);
      window.timedeal_badge.start_timer();
    }

    //특가 표시
    if(item_info.is_special_price !== undefined && item_info.is_special_price)
    {
      subcart_item_obj.find(".cl_special_price").css("display","inline-flex");
      subcart_item_obj.find(".checkbox").hide();
    }

    // title
    var prod_title = item_info.title;
    var variant_title = "";

    prod_title = window.decorate_product_title(prod_title);


    if(item_info.variant_title !== "")
    {
      variant_title = "<div>" + item_info.variant_title + "</div>";
    }
    subcart_item_obj
      .find(".cl_title")
      .attr("href", item_info.url + _dev_view_layout_selector2)
      .html(prod_title + variant_title);

    //gift card message
    var $gift_card_wrap = subcart_item_obj.find(".gift-card-wrap");
    if(item_info.product_type === "Gift Cards" && !is_empty(item_info.attributes))
    {
      $gift_card_wrap.show();
      $gift_card_wrap.find(".email .value").html(item_info.attributes['gift_card_email']);
      $gift_card_wrap.find(".recipient .value").html(item_info.attributes['gift_card_recipient']);
      $gift_card_wrap.find(".message .value").html(item_info.attributes['gift_card_message']);

    }else{
      $gift_card_wrap.hide();
    }

    // remove link
    subcart_item_obj
      .find(".cart-remove-wrap")
      .attr("variant_id", item_info.variant_id);
      //.attr("href", "/cart/change?line=" + index + "&amp;quantity=0");

    // price
    subcart_item_obj
      .find(".one-quarter .h5")
      .eq(0)
      .html(item_info.price_str);

    // point
    subcart_item_obj
      .find(".one-quarter .h5")
      .eq(1)
    .html(get_cpoint_from_point(item_info.point));

    // quantity input

    if(item_info.product_type === "Gift Cards")
    {
      subcart_item_obj
              .find(".cart__quantity-selector").hide();
    }else{
      subcart_item_obj
              .find(".cart__quantity-selector")
              .attr("id", "updates_" + item_info.variant_id)
              .attr("variant_id", item_info.variant_id)
              .attr("org_qty", item_info.quantity)
              .attr("max_cart_quantity", item_info.max_cart_quantity)
              .val(item_info.quantity)
              .inputSpinner(); //bootstrap-input-spinner 초기화
    }


    // line_price
    subcart_item_obj
      .find(".one-quarter .h5")
      .eq(2)
      .html(item_info.line_price_str)
      .removeClass("spinner");


     var checkbox_obj = subcart_item_obj.find(".subcart_item_chk");

    //상품체크 상태 표시
    if(item_info.checked_yn === "Y") checkbox_obj.prop("checked",true);
    else checkbox_obj.prop("checked",false);

    // 판매상태 (상품의 판매상태에 따라, 체크박스와 수량변경 버튼등을 비활성화한다.)
    show_product_status(item_info,subcart_item_obj);


    //증정품
    if(item_info.is_giveaway !== undefined && item_info.is_giveaway)
    {
      let phrase_idx = prod_title.indexOf("[증정품]");
      if(phrase_idx >= 0){
        prod_title = prod_title.replace("[증정품]","");
        var phrase = "<span class='giveaway'>증정품</span>";
        prod_title = phrase + prod_title;
      }

      subcart_item_obj.find(".cl_title").removeAttr("href").html(prod_title + variant_title);
      subcart_item_obj.find(".cart__image").removeAttr("href");


      if(item_info.event_title !== undefined)
      {
        subcart_item_obj.find(".cl_subtitle").html(item_info.event_title);
      }

      subcart_item_obj.find(".checkbox").hide();
      subcart_item_obj.find(".cart-remove-wrap").hide();
      subcart_item_obj.find(".price-wrap").hide();
      subcart_item_obj.find(".reserve-point-wrap").hide();
      subcart_item_obj.find(".quantity-wrap").hide();
      subcart_item_obj.find(".price-sum-wrap").hide();
      //subcart_item_obj.addClass("background-effect");
    }
  }

  function show_product_status(item_info, $subcart_item)
  {
    // 판매상태 (상품의 판매상태에 따라, 체크박스와 수량변경 버튼등을 비활성화한다.)
    var $checkbox = $subcart_item.find(".subcart_item_chk");
    var status_title = null;


    switch (item_info.product_status){
      case "PS_NOT_FOR_SALE":
      case "PS_DELETED":
        status_title = "판매하지않음";
        break;
      case "PS_SOLD_OUT":
        status_title = "품절";
        break;
      case "PS_COMING_SOON":
        status_title = "Coming soon";
        break;
    }

    if(status_title == null
            && item_info.is_special_price !== undefined && item_info.is_special_price
            && item_info.is_achieved_special_price !== undefined && !item_info.is_achieved_special_price){
      status_title = "구매조건 미달";
      $subcart_item.find(".cl_item_status").css("background-color","#ef3e3d").css("color","white");
    }

    if(status_title != null)
    {
      //alert("product_stock_info.product_status : " + product_stock_info.product_status);
      $checkbox.prop("checked",false);
      //on_change_cart_checkbox(checkbox_obj);//cart.liquid
      $subcart_item.find(".checkbox").hide();
      $subcart_item.find(".input-group").hide();
      $subcart_item.find(".cl_item_status").css("display","inline-block").css("opacity",1);
      $subcart_item.find(".cl_item_status").html(status_title);
      $subcart_item.find("#id_line_price_sum").hide();

    }else{
      $subcart_item.find(".checkbox").show();
      $subcart_item.find(".input-group").show();
      $subcart_item.find(".cl_item_status").hide().css("opacity",0);
      $subcart_item.find("#id_line_price_sum").show();
    }
  }

  //주문합계 , 적립꽃송이 합계
  function show_subcart_sum_info(subcart_id)
  {

    var subcart_obj = get_subcart_obj(subcart_id);

    var subcart_info = get_subcart_by_id(subcart_id);

    subcart_info.checked_total_price = 0;
    subcart_info.checked_total_price_str = "";
    subcart_info.checked_total_point = 0;
    subcart_info.checked_total_point_str = "";
    subcart_info.checked_item_list = [];

    var is_exist_special_price_item = false;
    for(var i = 0; i < subcart_info.item_list.length; i++)
    {
      var item_info = subcart_info.item_list[i];
      var checkbox_obj = $(subcart_obj).find(".subcart_item_chk[variant_id='" +item_info.variant_id+"']");

      item_info.is_achieved_special_price = false;

      if(item_info.is_special_price !== undefined && item_info.is_special_price)
      {
        is_exist_special_price_item = true;
        continue;
      }
      if( checkbox_obj.prop('checked') && item_info.checked_yn === "Y")
      {
        subcart_info.checked_total_price += item_info.line_price;
        subcart_info.checked_total_point += item_info.line_point;
        subcart_info.checked_item_list.push(item_info);
      }
    }

    //특가 아이템 조정(무료배송조건 도달시에만 유효상품으로 취급한다)
    if(is_exist_special_price_item)
    {
      var free_shipping_thresold_price = get_free_shipping_thresold_price(subcart_id);

      for(var i = 0; i < subcart_info.item_list.length; i++)
      {
        var item_info = subcart_info.item_list[i];

        if( item_info.is_special_price !== undefined && item_info.is_special_price)
        {
          var $subcart_item = $(subcart_obj).find(".cart__row[variant_id='" + item_info.variant_id+"']");
          //var $special_price_wrap = $subcart_item.find(".cl_special_price");

          if( free_shipping_thresold_price > 0 && subcart_info.checked_total_price >= free_shipping_thresold_price)
          {
            var $checkbox_input = $subcart_item.find(".subcart_item_chk[variant_id='" +item_info.variant_id+"']");
            var $checkbox_wrap = $checkbox_input.closest(".checkbox");




            //$special_price_wrap.addClass("active");
            $checkbox_wrap.show();
            item_info.is_achieved_special_price = true;

           // alert(item_info.title);


            if($checkbox_input.prop('checked') && item_info.checked_yn === "Y")
            {
              subcart_info.checked_total_price += item_info.line_price;
              subcart_info.checked_total_point += item_info.line_point;
              subcart_info.checked_item_list.push(item_info);
            }
          }
          else
          {
            //$special_price_wrap.removeClass("active");
            item_info.is_achieved_special_price = false;

          }
          show_product_status(item_info,$subcart_item);

        }
      }

    }

    subcart_info.checked_total_price = subcart_info.checked_total_price.toFixed(2);
    subcart_info.checked_total_price_str = "$" + subcart_info.checked_total_price;
    subcart_info.checked_total_point_str = subcart_info.checked_total_point.toFixed(2);

    // total_price
	var total_order_price_obj = subcart_obj.find("#id_total_order_price");
    total_order_price_obj.removeClass("spinner");
    total_order_price_obj.html(subcart_info.checked_total_price_str);
    total_order_price_obj.removeAttr("style");

    // total_point
    var total_order_point_obj = subcart_obj.find("#id_total_order_point");
    total_order_point_obj.removeClass("spinner");
    total_order_point_obj.html(get_cpoint_from_point(subcart_info.checked_total_point));
    total_order_point_obj.removeAttr("style");

  }




  var get_cart_info_ajax = function(callback)
  {
    $.ajax
    ({
      type		: "GET",
      url		: "/cart.js",
      cache		: false,
      dataType	: "json",
      async		: false,
      success		: function(jsonData)
      {
        //_console_log("[cart.js::RESPONSE]");
        //_console_log(jsonData);

        if(jsonData.token != null)
        {
          //_cart_token = jsonData.token;
          //_console_log("[cart_token] : (" + _cart_token + ")");
          callback(jsonData);
        }
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        show_ajax_response_error("1002", XMLHttpRequest, textStatus, errorThrown);
      }
    });
  };



  function change_quantity_in_extcart_with_obj(input_obj)
  {
    var subcart_id = input_obj.closest(".cl_subcart").attr("subcart_id");

    variant_id = input_obj.attr("variant_id");
    new_qty = input_obj.val();
    org_qty = input_obj.attr("org_qty");
	max_qty = input_obj.attr("max_cart_quantity") * 1;

    if(new_qty == "")
    {
      //alert("수량을 입력해 주세요.");
      //input_obj.focus();
      input_obj.val(org_qty);
      return false;
    }

    if(!is_number(new_qty))
    {
      //alert("수량을 0 이상의 숫자로 입력해 주세요.");
      //input_obj.focus();
      input_obj.val(org_qty);
      return false;
    }

    /*if(new_qty == org_qty)
    {
      alert("수량이 수정되지 않았습니다.\n변경하실 수량을 입력해 주세요.");
      input_obj.focus();
      return true;
    }*/

    //최대구매수량 초과확인
    if(max_qty > 0 && new_qty >= max_qty)
    {
      showSnackbar("최대 " + max_qty + "개까지만 구매하실 수 있는 상품입니다.");
      input_obj.val(max_qty);
      if(new_qty > max_qty){
      	return false;
      }
    }

    //Line Item 가격합계에 Spinner 적용
    var line_price_sum_obj = input_obj.parent().parent().find("#id_line_price_sum");
    var line_price_sum_class = line_price_sum_obj.attr('class');
    if(line_price_sum_class.indexOf("spinner") < 0)
    {
      line_price_sum_obj.addClass("spinner");
      line_price_sum_obj.html("&nbsp;&nbsp;&nbsp;&nbsp;");
    }

    //장바구니 가격합계에 Spinner적용
    var cart_price_sum_obj = input_obj.closest(".cl_subcart").find("#id_total_order_price");
    var cart_price_sum_class = cart_price_sum_obj.attr('class');
    if(cart_price_sum_class.indexOf("spinner") < 0)
    {
      cart_price_sum_obj.addClass("spinner");
      cart_price_sum_obj.html("&nbsp;&nbsp;&nbsp;&nbsp;");
      cart_price_sum_obj.css("position","relative").css("margin-right","10%");
    }

    //장바구니 포인트합계에 Spinner적용
    var cart_point_sum_obj = input_obj.closest(".cl_subcart").find("#id_total_order_point");
    var cart_point_sum_class = cart_point_sum_obj.attr('class');
    if(cart_point_sum_class.indexOf("spinner") < 0)
    {
      cart_point_sum_obj.addClass("spinner");
      cart_point_sum_obj.html("&nbsp;&nbsp;&nbsp;&nbsp;");
      cart_point_sum_obj.css("position","relative").css("margin-right","10%");
    }

    //적립포인트 계산
    //input_obj.closest(".cl_subcart").find(".one-quarter .h5").eq(1).html(get_cpoint_from_point(item_info.point * new_qty));


    change_quantity_in_extcart(subcart_id,variant_id, new_qty);
  }

  function change_quantity_in_extcart(subcart_id,variant_id, quantity)
  {
    if(quantity <= 0)
    {
      change_quantity_in_extcart_ajax(proceed_after_deleting_product_from_extcart, subcart_id, variant_id, quantity);
    }
    else
    {
      change_quantity_in_extcart_ajax(proceed_after_changing_quantity_in_extcart, subcart_id, variant_id, quantity);
    }
  }

  var change_quantity_in_extcart_ajax = function(callback, subcart_id, variant_id, quantity)
  {
    if(_quantity_ajax != null)
    {
      _quantity_ajax.abort();
      _quantity_ajax = null;
    }

    _quantity_ajax = $.ajax
    ({
      type		: "POST",
      url		: _ext9api_url,
      data		:
      {
        action: "change_quantity_in_extcart",
        cart_token: _cart_token,
        customer_id: _customer_id,
        product_id: null,
        variant_id: variant_id,
        quantity: quantity
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
        _console_log(jsonData);
        if(jsonData.result_code != null)
        {
          _console_log("[RESPONSE] (" + jsonData.result_code + ") " + jsonData.result_msg);
        }

        callback(subcart_id,jsonData);
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        //show_ajax_response_error("1005", XMLHttpRequest, textStatus, errorThrown);
      },
      complete : function()
      {
        _quantity_ajax = null;
      }
    });
  }

  function proceed_after_changing_quantity_in_extcart(subcart_id,resp_json)
  {
    //_console_log("[RESPONSE]");
    //_console_log(resp_json.extcart_info);
    if(resp_json.result_code !== "S0000")
    {
      hideLoadingSpinner();
      show_snackbar("수량을 변경할 수 없습니다.");
      return;
    }

    show_header_cart_count(resp_json.extcart_info);

    set_extcart_info(resp_json.extcart_info);

    show_subcart(subcart_id);

    if(!is_empty(resp_json.quantity_info) && resp_json.quantity_info.is_over_max_quantity)
    {
      showSnackbar("최대  " + resp_json.quantity_info.max_cart_quantity + "개까지만 구매하실 수 있는 상품입니다.");
    }

    //alert("수량이 변경되었습니다.");
  }

  function proceed_after_deleting_product_from_extcart(subcart_id,resp_json)
  {
    //_console_log("[RESPONSE] :: proceed_after_deleting_product_from_extcart");
    ///_console_log(resp_json);
    if(resp_json.result_code !== "S0000")
    {
      hideLoadingSpinner();
      show_snackbar("수량을 변경할 수 없습니다.");
      return;
    }

    show_header_cart_count(resp_json.extcart_info);

    set_extcart_info(resp_json.extcart_info);

    show_subcart(subcart_id);

    showSnackbar("상품이 삭제되었습니다.");
    //alert("상품이 삭제되었습니다.");
  }

  function checkout_subcart(subcart_id, shipping_addr_obj)
  {
    if(_quantity_ajax != null) return false;

//    var cart_update_json = {updates: {31769818892: 2, 31771391500: 3}};
    var cart_update_obj = {};
    cart_update_obj.updates = {};

    extcart_info = get_extcart_info();

    //_console_log("[checkout_subcart::extcart_info]");
    //_console_log(extcart_info);

    if(subcart_id == _k2k_subcart_id)
    {
      cart_relay_container_obj = {};
      cart_relay_container_obj.uscid = _customer_id;
      cart_relay_container_obj.email = _customer_email;
      cart_relay_container_obj.ctk = _cart_token;
      cart_relay_container_obj.shipping_addr = shipping_addr_obj;

      cart_relay_container = JSON.stringify(cart_relay_container_obj);
      cart_relay_container_enc = encodeURIComponent(cart_relay_container);

      //document.location.href = "//" + _k2k_domain + "/cart?us_customer_id=" + _customer_id;
      document.location.href = "//" + _k2k_domain + "/cart?cart_relay_container=" + cart_relay_container_enc + "&us_customer_id=" + _customer_id;

      return true;
    }



    var subcart_info = get_subcart_by_id(subcart_id);
    var item_list = subcart_info != null ? subcart_info.checked_item_list : [];

    reset_cart_and_checkout(subcart_id,item_list);
  }

// [NOTE] checkout_subcart() 대신 checkout_checked_subcart() 가 사용되고 있음.
  function checkout_checked_subcart(subcart_id,item_list)
  {
    console.log(">> 2. [extcart.js] checkout_checked_subcart() called.");
    if(_quantity_ajax != null) return false;

    reset_cart_and_checkout(subcart_id,item_list);
  }

  function reset_cart_and_checkout(subcart_id,item_list)
  {
    console.log(">> 3. [extcart.js] reset_cart_and_checkout() called. Now clearing cart...");
    var cart_update_obj = {};
    cart_update_obj.updates = {};

/*
    var test_item_info = new Object();
    test_item_info.variant_id = '39832174919766';
    test_item_info.quantity = 1;
    item_list.push(test_item_info);
*/

    /*/ [NOTE] [GIVEAEAY] 증정품 관련 로직을 서버로 일원화
    // 2024.6.22 by Hyun Kim <hkim@cconma.com>
    if((typeof _customer_id != 'undefined' && (
      _customer_id == "3985635014" ||
      _customer_id == "4781521740" || // sonbohoon
      _customer_id == "5297210572" || // jaebong
      _customer_id == "5611738333270" || // jaimelee
      _customer_id == "5439288934486" // hyemoon1009
      ))
      || true // OPEN TO ALL
    ) {

        make_up_promotion_cart_ajax(update_cart_and_checkout_wrap, subcart_id, item_list);

        return true;
    }
    /**/

    // update_cart_and_checkout_wrap() 함수로 이동

    for(var i = item_list.length - 1 ;i >= 0 ; i--)
    //for(var i = 0 ;i < item_list.length ; i++)
    {
      item_info = item_list[i];
      cart_update_obj.updates[item_info.variant_id] = item_info.quantity;
    }

    cart_update_json = JSON.stringify(cart_update_obj);

    var params = new Array();
    params[0] = cart_update_json;
    params[1] = subcart_id;
    params[2] = item_list;

    truncate_cart_ajax(update_cart_and_checkout, params);

  }

  function update_cart_and_checkout_wrap(jsonData)
  {
    var cart_update_obj = {};
    cart_update_obj.updates = {};

    var subcart_id = jsonData.container.subcart_id;
    var item_list = jsonData.container.item_list;

    for(var i = item_list.length - 1 ;i >= 0 ; i--)
    //for(var i = 0 ;i < item_list.length ; i++)
    {
      item_info = item_list[i];
      cart_update_obj.updates[item_info.variant_id] = item_info.quantity;
    }

    cart_update_json = JSON.stringify(cart_update_obj);

    var params = [];
    params[0] = cart_update_json;
    params[1] = subcart_id;
    params[2] = item_list;

    truncate_cart_ajax(update_cart_and_checkout, params);
  }


  var make_up_promotion_cart_ajax = function(callback, subcart_id, item_list)
  {
    $.ajax
    ({
      type		: "POST",
      url		: _extapi_url,
      data		:
      {
        action: "make_up_promotion_extcart",
        cart_token: _cart_token,
        customer_id: _customer_id,
        subcart_id: subcart_id,
        item_list_json: JSON.stringify(item_list)
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
        if(jsonData.result_code != null)
        {
          _console_log("[RESPONSE] (" + jsonData.result_code + ") " + jsonData.result_msg);
        }

        if(jsonData.result_code == "S0000")
        {
          callback(jsonData);
        }
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        show_ajax_response_error("1004", XMLHttpRequest, textStatus, errorThrown);
      },
      complete : function()
      {
      }
    });
  };

  function update_cart_and_checkout(resp_json, params)
  {
    console.log(">> 5. [extcart.js] update_cart_and_checkout() called. Cart cleared, now updating cart with new items...");
    showLoadingSpinner();

    cart_update_json = params[0];
    update_cart_ajax(submit_subcart_to_checkout, cart_update_json, params);

  }

  var update_cart_ajax = function(callback, cart_update_json, params)
  {
    console.log(">> 6. [extcart.js] update_cart_ajax() called. Sending /cart/update.js request.");
    var url = "/cart/update.js";

    if(params[1] == _k2k_subcart_id)
    {
      url = _k2k_home_url + url;
    }

    $.ajax
    ({
      type		: "POST",
      url		: url,
      data		: cart_update_json,
      contentType: "application/json; charset=utf-8",
      cache		: false,
      dataType	: "json",
      async		: false,
      success		: function(jsonData)
      {
        console.log(">> 7. [extcart.js] update_cart_ajax() SUCCESS. Cart updated.");
        //_console_log("[cart.js::RESPONSE]");
        //_console_log(jsonData);

        if(jsonData.token != null)
        {
          callback(jsonData, params);
        }
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        console.error(">> ERROR in update_cart_ajax().");
        _console_log(XMLHttpRequest);
        /*if(XMLHttpRequest.status == 422)
        {
          respText = JSON.parse(XMLHttpRequest.responseText);

          alert("아래의 이유로 주문을 진행할 수 없습니다.\n\n" +
                respText.description);
        }
        else
        {
          show_ajax_response_error("1006", XMLHttpRequest, textStatus, errorThrown);
        }*/
        show_update_cart_response_message(XMLHttpRequest);
      }
    });
  }

  function show_update_cart_response_message(XMLHttpRequest)
  {
    if(XMLHttpRequest.status == 422)
    {
      respText = JSON.parse(XMLHttpRequest.responseText);

      // sold out
      head_str = "The product '";
      tail_str = "' is already sold out.";
      head_idx = respText.description.indexOf(head_str);
      tail_idx = respText.description.indexOf(tail_str);
      if(head_idx != -1&& tail_idx > 0)
      {
        soldout_product_title = respText.description.substring(head_str.length, tail_idx);

        alert("아래의 상품이 품절입니다. 상품을 삭제하시고 주문을 해주세요.\n\n" +
              "[ " + soldout_product_title + " ]");

        hideLoadingSpinner();	//Snippets/cc_loading_spinner.lipquid
        return;
      }

      alert("아래의 이유로 주문을 진행할 수 없습니다.\n\n" +
            respText.description);
    }
    else
    {
      alert("아래의 이유로 주문을 진행할 수 없습니다.\n\n" +
            "[" + XMLHttpRequest.status + "] " +
            XMLHttpRequest.responseText);
    }
    hideLoadingSpinner();	//Snippets/cc_loading_spinner.lipquid
  }

  function submit_subcart_to_checkout(resp_json, params)
  {
    console.log(">> 8. [extcart.js] submit_subcart_to_checkout() called. Preparing to redirect to checkout.");
    //_console_log("[RESPONSE::update_cart_ajax]");
    //_console_log(resp_json);

    showLoadingSpinner();

    subcart_id = params[1];
    item_list = params[2];
    generate_form_and_checkout(subcart_id,item_list);

    //app 인경우 결제페이지로 이동하기전 앱바를 가려줘야함.
    hide_appbar();
  }

  function generate_form_and_checkout(subcart_id,item_list)
  {
    //debugger;

    console.log(">> 9. [extcart.js] generate_form_and_checkout() called. Creating form and submitting.");
    var url = "/cart";

    if(subcart_id == _k2k_subcart_id)
    {
      url = _k2k_home_url + url;
    }


    var form =
        $("<form/>", {
          action : url,
          method : "post",
          id : "checkout_form",
          novalidate : 'novalidate',
          class : "cart"
        });

    $container = $("#tab-content-" + subcart_id);
    subcart_note = $container.find("textarea[name=note]").val();

    //subcart_note = $("#id_mobile_wrapper[subcart_id='" + subcart_id + "'] textarea[name='note']").val();
    //gift_message = $("#id_mobile_wrapper[subcart_id='" + subcart_id + "'] textarea[name='gift_message']").val();

    /**/
    form.append(
      $("<textarea>",
        {
        name : "note",
        class : "input-full",
        id : "CartSpecialInstructions"
      })
      .html(subcart_note)
      //.html('This is a test note.')
    );


    // --- 장바구니 복원을 위해, 주문하지 않을 상품 정보를 cart.attribute에 저장 ---
    const $checkedItems = $container.find('.item-check:checked');
    const allCartItems = window._native_cart_items || []; // cart.liquid에서 저장한 전역 변수 사용
    const checkedVariantIds = $checkedItems.map(function () {
      return $(this).data('id');
    }).get(); // 여기서 data-id는 number일 수 있으므로, 비교 시 주의
    const itemsToRestore = allCartItems
            .filter(item => !checkedVariantIds.includes(item.variant_id))
            .map(item => ({id: item.variant_id, quantity: item.quantity}));

    /*
    const restorePayload = {
      attributes: { '__restore_items': JSON.stringify(itemsToRestore) }
    };

    // cart.attributes를 먼저 업데이트합니다.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(restorePayload)
    }).then(() => {


    }); */
    alert(JSON.stringify(itemsToRestore));
    // [NOTE] 장바구니 복원 정보가 계속 남아있기위해,
    // 결제 진행 시 복원 정보를 담고 있는 attribute를 명시해줍니다.
    form.append(
            $("<input>", {
              type : 'hidden',
              name : "attributes[restore_items]",
              value: JSON.stringify(itemsToRestore)
            })
    );

    form.append(
      $("<input>",
        {
        type : 'hidden',
        name : "attributes[subcart_id]",
          value: "subcart_id_TEST"
      }));



    if(subcart_id === "SUBCART_15" && item_list.length > 0 && item_list[0].cart_token !== undefined)
    {
      form.append(
        $("<input>",
          {
            type : 'hidden',
            name : "attributes[gitf_card_cart_token]",
            value : item_list[0].cart_token
        }));
    }


    form.append(
      $("<input>",
        {
        type : 'submit',
        name : 'checkout',
        class : 'cl_btn',
        value : 'Checkout'
      }));


    //$("#div_checkout_form_container").html("");
    $container.append(form);

    setTimeout(function () {
      form.find("input[name='checkout']").click();
    }, 0);
  }


  function get_note_message(subcart_id)
  {
    return $("#id_mobile_wrapper[subcart_id='" + subcart_id + "'] textarea[name='note']").val();
  }

  function get_gift_message(subcart_id)
  {
    return $("#id_mobile_wrapper[subcart_id='" + subcart_id + "'] textarea[name='gift_message']").val();
  }

  function save_subcart_message(subcart_id)
  {
    // [NOTE] 네이티브 장바구니 전환을 위해, 기존 #id_mobile_wrapper DOM 대신 cart.liquid의 DOM에서 메모를 가져옵니다.
    // subcart_note = $("#id_mobile_wrapper[subcart_id='" + subcart_id + "'] textarea[name='note']").val();
    // gift_message = $("#id_mobile_wrapper[subcart_id='" + subcart_id + "'] textarea[name='gift_message']").val();

    var subcart_note = $("#CartNote-" + subcart_id).val();
    var gift_message = ""; // 현재 네이티브 장바구니에는 gift_message 필드가 없습니다.

    save_subcart_message_ajax(null, subcart_note, gift_message);
  }

  var _is_done_saving_subcart_message = false;

  var save_subcart_message_ajax = function(callback, cart_note, gift_message)
  {
    $.ajax
    ({
      type		: "POST",
      //url		: _ext9api_url,
      url		: _extapi_url,
      data		:
      {
        action: "save_subcart_message",
        cart_token: _cart_token,
        customer_id: _customer_id,
        subcart_id: _k2k_subcart_id,
        cart_note: cart_note,
        gift_message: gift_message
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
        _is_done_saving_subcart_message = true;
        console.log("Saving subcart messages DONE.");
        if(jsonData.result_code != null)
        {
          if(callback != null)
          {
            callback(jsonData);
          }
        }
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        _is_done_saving_subcart_message = true;
        show_ajax_response_error("1007", XMLHttpRequest, textStatus, errorThrown);
      }
    });
  };


  function set_checked_yn_on_extcart_info(subcart_id, variant_id, checked_yn)
  {
    var subcart_info = get_subcart_by_id(subcart_id);

    for(var i = 0; i < subcart_info.item_list.length; i++)
    {
      if(subcart_info.item_list[i].variant_id == variant_id)
      {
        subcart_info.item_list[i].checked_yn = checked_yn;
      }

    }
  }

  var sync_extcart_checkbox_ajax = function(subcart_info)
  {
    var data_obj = {};
    data_obj.customer_id = _customer_id;
    data_obj.cart_token = _cart_token;
    data_obj.item_list = subcart_info.item_list;
    data_obj.subcart_id = subcart_info.subcart_id;
    var data_json = JSON.stringify(data_obj);

    if(_checkbox_ajax != null)
    {
      _checkbox_ajax.abort();
      _checkbox_ajax = null;
    }

    _checkbox_ajax = $.ajax
    ({
      type		: "POST",
      url		: _extapi_url +"?action=update_items_check_status",
      data		: data_json,
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
        if(jsonData.result_code != null)
        {
          _console_log("[RESPONSE]::sync_extcart_checkbox_ajax");
          _console_log(jsonData);
        }

        if(jsonData.result_code == "S0000")
        {
          if( jsonData.subcart_id !== undefined && jsonData.item_list !== undefined){
            set_subcart_item_list(jsonData.subcart_id,jsonData.item_list);
            show_subcart(jsonData.subcart_id)
          }
        }
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        //show_ajax_response_error("1008", XMLHttpRequest, textStatus, errorThrown);
      },
      complete : function()
      {
        _checkbox_ajax = null;
      }
    });
  }
